const ContactMail = ({
  width = 61,
  height = 61,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 61 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1185_45868)">
        <g clipPath="url(#clip1_1185_45868)">
          <g clipPath="url(#clip2_1185_45868)">
            <mask
              id="mask0_1185_45868"
              //   style="mask-type:luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="61"
              height="61"
            >
              <path
                d="M60.6602 0.28125H0.660156V60.2812H60.6602V0.28125Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_1185_45868)">
              <path
                d="M30.6602 60.2812C47.2287 60.2812 60.6602 46.8498 60.6602 30.2812C60.6602 13.7127 47.2287 0.28125 30.6602 0.28125C14.0916 0.28125 0.660156 13.7127 0.660156 30.2812C0.660156 46.8498 14.0916 60.2812 30.6602 60.2812Z"
                fill="#DDF3F6"
              />
              <path
                d="M43.9941 35.5336C43.9941 39.2536 41.0075 42.2668 37.2876 42.2801H37.2742H24.0612C20.3547 42.2801 17.3281 39.2802 17.3281 35.5603V35.547C17.3281 35.547 17.3361 29.6458 17.3467 26.6779C17.3481 26.1206 17.9881 25.8086 18.424 26.1552C21.592 28.6685 27.2572 33.251 27.3278 33.311C28.2745 34.0697 29.4744 34.4977 30.7011 34.4977C31.9277 34.4977 33.1277 34.0697 34.0743 33.2964C34.145 33.2497 39.6835 28.8045 42.8994 26.2499C43.3367 25.9019 43.9794 26.2139 43.9807 26.7699C43.9941 29.7151 43.9941 35.5336 43.9941 35.5336Z"
                fill="#133345"
              />
              <path
                d="M43.2928 21.8465C42.1381 19.6705 39.8662 18.2812 37.3649 18.2812H24.0586C21.5573 18.2812 19.2854 19.6705 18.1307 21.8465C17.8721 22.3331 17.9947 22.9399 18.4254 23.2839L28.3251 31.2023C29.0185 31.7623 29.8584 32.041 30.6984 32.041C30.7038 32.041 30.7078 32.041 30.7118 32.041C30.7158 32.041 30.7211 32.041 30.7251 32.041C31.5651 32.041 32.405 31.7623 33.0984 31.2023L42.9981 23.2839C43.4288 22.9399 43.5514 22.3331 43.2928 21.8465Z"
                fill="#133345"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1185_45868">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.660156 0.28125)"
          />
        </clipPath>
        <clipPath id="clip1_1185_45868">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.660156 0.28125)"
          />
        </clipPath>
        <clipPath id="clip2_1185_45868">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.660156 0.28125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ContactMail;
